/**
 * Auto-scroll the page so the currently-playing track is kept in view.
 *
 * Shared by the regular playlist (TrackList.vue) and the poll views
 * (PollVoteList.vue, PollResultsTable.vue). Each of those renders one element
 * per track with id="trackID<id>", so the same DOM-id lookup works everywhere.
 *
 * The track list scrolls the window (not an inner scroll container); the player
 * is `position: fixed` at the top, so its bottom edge marks the top of the
 * visible track area.
 */
export default {
  methods: {
    scrollToTrackIfNeeded(trackID) {
      const element = document.getElementById('trackID' + trackID);

      if (!element) return;

      // Where the track sits right now relative to the viewport.
      const rect = element.getBoundingClientRect();
      const windowHeight = window.innerHeight || document.documentElement.clientHeight;

      // The fixed player overlaps the top of the page; treat its bottom edge as
      // the top of the visible track area.
      const playerContainer = document.querySelector('.playerContainer');
      const playerHeight = playerContainer ? playerContainer.getBoundingClientRect().bottom : 0;

      // Already fully visible below the player? Leave the scroll position alone
      // so we don't yank the page on every track change.
      const isVisible = rect.top >= playerHeight && rect.bottom <= windowHeight;
      if (isVisible) return;

      // Center the track in the visible area below the fixed player.
      const visibleAreaHeight = windowHeight - playerHeight;
      const targetPosition = playerHeight + (visibleAreaHeight / 2);
      const offset = targetPosition - (element.offsetHeight / 2);

      this.$vuetify.goTo(element, {
        duration: 500,
        offset: offset,
        easing: 'easeInOutCubic',
      });
    },

    // Wait for the DOM to render the (possibly new) row, then give layout a
    // moment to settle before measuring/scrolling.
    scheduleScrollToTrack(trackID) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.scrollToTrackIfNeeded(trackID);
        }, 100);
      });
    },
  },
};
